import React, { Component } from "react";
import { connect } from "react-redux";
import CardForm from "Utils/Cards/CardForm";
import { AnalisisForm } from "../components/AnalisisForm";
import "../styles/DetalleSolicitud.css";

class AnalisisDRC extends Component {
    state = {
        analisisId: null,
        tipoSolicitud: null,
    };

    componentWillMount() {
        this.setState({ analisisId: this.props.match.params.id });
    }

    regresar = () => {
        this.props.history.goBack();
    };

    setTipoSolicitud = (tipo) => {
        this.setState({ tipoSolicitud: tipo });
    };

    render() {
        const { configuraciones } = this.props;
        const rangoDRC = configuraciones && configuraciones.variable_rango_drc;

        return (
            <div className="mb-4 col-12" style={{ maxWidth: "95vw" }}>
                <CardForm
                    icon="laboratorio_activo"
                    titulo="Análisis DRC Producción"
                    subtitulo={
                        this.state.tipoSolicitud || "Sobrante de almacén"
                    }
                    col="12"
                >
                    <AnalisisForm
                        analisisId={this.state.analisisId}
                        modo="analisis"
                        regresar={this.regresar}
                        rangoDRC={rangoDRC}
                        setTipoSolicitud={this.setTipoSolicitud}
                    />
                </CardForm>
            </div>
        );
    }
}

const mstp = (state) => {
    const configuraciones = state.configuracion.configuraciones;
    const user = state.login.me;

    return {
        configuraciones,
        user,
    };
};

export default connect(mstp, {})(AnalisisDRC);
